module.exports = {
  "name": "ur_PK",
  "day": {
    "abbrev": ["اتوار", "پير", "منگل", "بدھ", "جمعرات", "جمعه", "هفته"],
    "full": ["اتوار", "پير", "منگل", "بدھ", "جمعرات", "جمعه", "هفته"]
  },
  "month": {
    "abbrev": ["جنوري", "فروري", "مارچ", "اپريل", "مٓی", "جون", "جولاي", "اگست", "ستمبر", "اكتوبر", "نومبر", "دسمبر"],
    "full": ["جنوري", "فروري", "مارچ", "اپريل", "مٓی", "جون", "جولاي", "اگست", "ستمبر", "اكتوبر", "نومبر", "دسمبر"]
  },
  "meridiem": ["ص", "ش"],
  "date": "%d/%m/%Y",
  "time24": "%H:%M:%S",
  "dateTime": "و %H:%M:%S %Z ت %d %B %Y",
  "time12": "%P %I:%M:%S"
};